export class AccredibleAuthenticationServiceConfig {
  app: 'rp' | 'acs' | 'sl' | 'cf';
}
